import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import LoadingScreen from './components/LoadingScreen';


const Loadable = (Component: any) => (props: any) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

// sending
const Layout = Loadable(lazy(() => import('./layouts/Layout')))
const Home = Loadable(lazy(() => import('./pages/HomePages')));
const Error = Loadable(lazy(() => import('./pages/ErrorPages')));


const routes: any = ([
  {
    path: '/',
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '*', element: <Navigate to="404" /> },
    ]
  },
  { path: '404', element: <Error /> },
]);

export default routes;
